export default __webpack_public_path__ + "static/media/element_41.970ec49d.jpg";